import lodash from 'lodash';
import WalletAccount from '../wallet-account/index.js';
import { ModelIdSymbol } from '../constants.js';
import { createIsInstance } from '../utils.js';
const { mapValues, mergeWith } = lodash;
const coerceToWalletAccount = (walletAccount) => (walletAccount instanceof WalletAccount ? walletAccount : new WalletAccount(walletAccount));
class WalletAccountSet {
    _byName;
    constructor(byName = {}) {
        this._byName = mapValues(byName, coerceToWalletAccount);
    }
    static get [ModelIdSymbol]() {
        return 'WalletAccountSet';
    }
    static isInstance = createIsInstance(WalletAccountSet);
    static [Symbol.hasInstance](instance) {
        return this.isInstance(instance);
    }
    static EMPTY = new WalletAccountSet();
    toJSON() {
        return mapValues(this._byName, (walletAccount) => walletAccount.toJSON());
    }
    toRedactedJSON() {
        return mapValues(this._byName, (walletAccount) => walletAccount.toRedactedJSON());
    }
    get(name) {
        if (name instanceof WalletAccount)
            name = name.toString();
        if (this._byName.hasOwnProperty(name)) {
            return this._byName[name];
        }
    }
    names() {
        return Object.keys(this._byName);
    }
    update(walletAccountsByName) {
        const byName = walletAccountsByName instanceof WalletAccountSet
            ? walletAccountsByName.toJSON()
            : walletAccountsByName;
        const updatedByName = mergeWith({ ...this._byName }, byName, (existing, updated) => existing ? existing.update(updated) : coerceToWalletAccount(updated));
        return new WalletAccountSet(updatedByName);
    }
    equals(walletAccountsByName) {
        if (this === walletAccountsByName)
            return true;
        const keys = Object.keys(walletAccountsByName.toJSON()).sort();
        const myKeys = this.names().sort();
        if (keys.length !== myKeys.length)
            return false;
        return myKeys.every((name) => {
            const myWalletAccount = this.get(name);
            const otherWalletAccount = walletAccountsByName.get(name);
            return otherWalletAccount && myWalletAccount.equals(otherWalletAccount);
        });
    }
}
export default WalletAccountSet;
